import { entityReportGQLFields, } from './entityReport.fields.js';
const BASIC_REPORT_DATA_VALUE_FIELDS = {};
const ALL_REPORT_DATA_VALUE_FIELDS = {
    onChartData: 'basic',
    onEntityReport: 'basic',
    onIntValue: 'basic',
    onStringValue: 'basic',
};
export function reportDataValueGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_REPORT_DATA_VALUE_FIELDS;
    if (fields === 'all')
        fields = ALL_REPORT_DATA_VALUE_FIELDS;
    return `
    __typename
    ${fields.onIntValue
        ? `
      ... on IntValue {
        int
      }
    `
        : ``}
    ${fields.onChartData
        ? `
      ... on ChartData {
        label
        points
        value
      }
    `
        : ``}
    ${fields.onEntityReport
        ? `
      ... on EntityReport {
        ${entityReportGQLFields(fields.onEntityReport)}
      }
    `
        : ``}
    ${fields.onStringValue
        ? `
      ... on StringValue {
        string
      }
    `
        : ``}
  `;
}
